import moment from 'moment';
import constants from 'core/constants';
import { hasFeature } from './feature-flags';
import shouldAppendIncludingToday from './should-append-including-today';

export default (dateType, includeTodayInToDates, hasGDFOption = false) => {
  let datePickerButtons = hasFeature('additional-date-ranges')
    ? constants.datePickerAdditionalButtons
    : constants.datePickerButtons;
  if (hasGDFOption) {
    datePickerButtons = [
      datePickerButtons[0],
      constants.datePickerCardDefault,
      ...datePickerButtons.slice(1),
    ];
  }
  if (dateType === constants.DATE_ONLY) {
    if (includeTodayInToDates) {
      return datePickerButtons.map((option) => {
        if (
          shouldAppendIncludingToday(option.id, dateType, includeTodayInToDates)
        ) {
          return { ...option, label: option.label + 'IncludingToday' };
        }
        return option;
      });
    }
    return datePickerButtons;
  }

  return datePickerButtons.map((option) => {
    const optionClone = { ...option };
    switch (optionClone.id) {
      case 'yesterday':
        optionClone.label = 'datePicker.presetMenu.last24Hours';
        optionClone.today = null;
        break;
      case 'last7Days':
        optionClone.start_date = new moment()
          .startOf('day')
          .subtract(6, 'days');
        optionClone.end_date = new moment();
        break;
      case 'last30Days':
        optionClone.start_date = new moment()
          .startOf('day')
          .subtract(29, 'days');
        optionClone.end_date = new moment();
        break;
      case 'last60Days':
        optionClone.start_date = new moment()
          .startOf('day')
          .subtract(59, 'days');
        optionClone.end_date = new moment();
        break;
      case 'last90Days':
        optionClone.start_date = new moment()
          .startOf('day')
          .subtract(89, 'days');
        optionClone.end_date = new moment();
        break;
      case 'last120Days':
        optionClone.start_date = new moment()
          .startOf('day')
          .subtract(119, 'days');
        optionClone.end_date = new moment();
        break;
      case 'last12Months':
        optionClone.start_date = new moment()
          .startOf('day')
          .subtract(364, 'days');
        optionClone.end_date = new moment();
        break;
    }
    return optionClone;
  });
};
